'use strict';

app.directive('modalTransclude', function () {
  return {
    link: function ($scope, $element) {
      $element.on('touchend', function (event) {
        event.stopPropagation();
      });
    }
  };
});
